import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Page } from "./page.model";

@Injectable()
export class PageService extends CrudService {
  getRootUrl(): string {
    return "pages";
  }

  save(page: Page) {
    return super.save(page);
  }

  saveMultiple(pages: Array<Page>) {
    return super.saveMultiple(pages);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/pages/shared/page.service.ts